import * as HoverTooltip from '@radix-ui/react-tooltip';

import useDeviceDetect from 'react-scale/hooks/useDeviceDetect';
import s from './tooltip.module.css';

const Tooltip = ({
  children,
  content,
  arrow = { align: 'center', offset: 0, width: 14, height: 8, className: '' }
}) => {
  const { isMobile } = useDeviceDetect();

  return isMobile ? (
    children
  ) : (
    <HoverTooltip.Root delayDuration={200}>
      <HoverTooltip.Trigger asChild className="cursor-auto">
        {children}
      </HoverTooltip.Trigger>
      <HoverTooltip.Content sideOffset={10} className={s.content} align={arrow.align}>
        {content}
        <HoverTooltip.Arrow
          className={arrow.className}
          offset={arrow.offset}
          width={arrow.width}
          height={arrow.height}
        />
      </HoverTooltip.Content>
    </HoverTooltip.Root>
  );
};

export default Tooltip;
